import type { FeedbackMessages } from './en';

const it: FeedbackMessages = {
  qualified: {
    title: 'Grazie per aver completato questo studio!',
    body1: 'Può chiudere la finestra del browser.',
    body2: 'Speriamo di rivederla presto.',
    refCode: 'Codice di riferimento: {code}',
  },
  quotaFull: {
    title: 'Questo studio è concluso',
    body1: 'Grazie per l’interesse mostrato verso il nostro studio.',
    body2: 'Purtroppo abbiamo già raccolto tutte le risposte di cui avevamo bisogno.',
    body3: 'Speriamo di rivederla in uno dei nostri futuri studi!',
    refCode: 'Codice di riferimento: {code}',
  },
  terminated: {
    title: 'Grazie per aver condiviso il suo feedback!',
    body1:
      'Speriamo di rivederla presto nei nostri futuri studi. Nel frattempo, le auguriamo una splendida giornata.',
    body2: 'La preghiamo di chiudere questa finestra del browser.',
    refCode: 'Codice di riferimento: {code}',
  },
  mismatch: {
    title: 'Grazie per il suo interesse',
    body1: 'Purtroppo non fa parte del gruppo target per questo specifico studio.',
    body2: 'Può chiudere questa pagina.',
    code: 'Codice: {code}',
  },
  error: {
    title: 'Non siamo in grado di elaborare la sua richiesta',
    linkProblemDetailed:
      'Il link che ha seguito presenta dei problemi. Verifichi che il link nella barra degli indirizzi corrisponda a quello che le è stato fornito e riprovi.',
    linkProblemGeneric:
      'Il link che ha seguito presenta dei problemi. La preghiamo di riprovare.',
    contactPerson:
      'Se il problema persiste, la preghiamo di informare la persona da cui ha ricevuto il link.',
    errorCode: 'Codice di errore: {code}',
  },
};

export default it;
